import React from 'react';

interface SidebarCardProps {
  title: string;
  children: React.ReactNode;
  /** Rodapé opcional, separado por régua (ex.: "Mais conteúdos MPF"). */
  footer?: React.ReactNode;
  className?: string;
}

/**
 * Casca dos três cards da coluna lateral da notícia: cabeçalho com título,
 * régua e corpo. Mantém borda, raio e sombra num lugar só.
 */
export const SidebarCard: React.FC<SidebarCardProps> = ({
  title,
  children,
  footer,
  className,
}) => (
  <section
    className={`mpf-news-sidebar__card${className ? ` ${className}` : ''}`}
  >
    <header className="mpf-news-sidebar__card-header">
      <h2 className="mpf-news-sidebar__card-title">{title}</h2>
    </header>
    <div className="mpf-news-sidebar__card-body">{children}</div>
    {footer ? (
      <div className="mpf-news-sidebar__card-footer">{footer}</div>
    ) : null}
  </section>
);

export default SidebarCard;
